import { type ValidationError } from '@adv-frontend/form-kit';

export const INVALID_EMAIL_FORMAT_CODE = 'INVALID_EMAIL_FORMAT';

export type InvalidEmailValidationError = ValidationError<typeof INVALID_EMAIL_FORMAT_CODE>;

export const INVALID_EMAIL_FORMAT_MESSAGE = 'Неверный формат электронной почты';
